export default __webpack_public_path__ + "static/media/StringSearchAlgorithm.869cbda1.jpg";